import React from 'react'
import { Grid } from '@mui/material'
import ProfileFormWrapper from 'components/wrappers/ProfileFormWrapper'
import { makeStyles } from '@mui/styles'
import { BaseMedia } from 'shared'

const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    welcomeVideo: {
      aspectRatio: '1.2 / 2',
      objectFit: 'cover',
      maxWidth: '350px',
      width: '100%',
      height: '621px',
      [theme.breakpoints.down('sm')]: {
        height: '75dvh',
      },
    },
  }
})

const ProfileFormGetStarted = () => {
  const classes = useStyles()

  return (
    <ProfileFormWrapper
      title="Welcome to the Hue Community"
      containerClassName={classes.container}
      stepDescription="Hi, beauty! Check out our video below to learn more about the Hue Community. Then, to get started, please submit an application to join our community. We’ll ask you a few questions so we can get to know you a bit better! This part should only take a few minutes."
    >
      <Grid
        flexGrow="1"
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <BaseMedia
          controls
          className={classes.welcomeVideo}
          src="https://hue-admin-dev.s3.amazonaws.com/assets/twin-portal/community-welcome-video.MOV"
        />
      </Grid>
    </ProfileFormWrapper>
  )
}

export default ProfileFormGetStarted
